import { NormalizedTicketTypeVariety } from '../../types/ticketPriceInformation';
import { core } from '@tock/coretypes';

export interface TicketTypeOption {
  key: string;
  label: string;
  value: NormalizedTicketTypeVariety;
}

export const fullTicketTypeOption: TicketTypeOption = {
  key: 'full',
  label: 'Pre-paid',
  value: 'FULL',
};

export const fullNoHyphenTicketTypeOption: TicketTypeOption = {
  key: 'full',
  label: 'Prepaid',
  value: 'FULL',
};

export const reservationTicketTypeOption: TicketTypeOption = {
  key: 'reservation',
  label: 'Reservation',
  value: 'RESERVATION',
};
export const basicTicketTypeOption: TicketTypeOption = {
  ...reservationTicketTypeOption,
  label: 'Basic',
};

const varietyMap: { [K in NormalizedTicketTypeVariety]: string } = {
  DEPOSIT: 'Deposit',
  FULL: 'Pre-paid',
  RESERVATION: 'Reservation',
  DEPRECATED_EVENT: 'Event',
  GA_EVENT: 'Event',
  SEATED_EVENT: 'Seated event',
  DEPRECATED_SPECIAL_TABLE: 'Special',
  ORDER_DELIVERY: 'Delivery',
  ORDER_PICKUP: 'Pickup',
  TABLESIDE: 'Tableside',
  PAYMENT_CARD_HOLD: 'Credit card hold',
};

/**
 * Returns a chip-friendly label matching a given variety.
 */
export const varietyChipLabel = (
  variety: NormalizedTicketTypeVariety,
  shouldUseUpdatedVarietyLabels = false
): string => {
  // TODO: clean up this conditional once CREDIT_CARD_HOLDS is released; IE replace 'Reservation' in varietyMap above with 'Standard'.
  if (shouldUseUpdatedVarietyLabels && variety === 'RESERVATION') {
    return basicTicketTypeOption.label;
  } else if (shouldUseUpdatedVarietyLabels && variety === 'FULL') {
    return fullNoHyphenTicketTypeOption.label;
  } else {
    return varietyMap[variety];
  }
};

// TODO: Delete the code below (type, const, and function) when cleaning up SEATING_AREAS
export type VarietyChipLabel =
  | 'Deposit'
  | 'Prepaid'
  | 'Reservation'
  | 'Event'
  | 'General admission'
  | 'Seated event'
  | 'Special table'
  | 'Delivery'
  | 'Pickup'
  | 'Tableside';
const varietyToVarietyChipLabelMapOld: {
  [K in core.TicketType.Variety]: VarietyChipLabel;
} = {
  DEPOSIT: 'Deposit',
  FULL: 'Prepaid',
  RESERVATION: 'Reservation',
  DEPRECATED_EVENT: 'Event',
  GA_EVENT: 'General admission',
  SEATED_EVENT: 'Seated event',
  DEPRECATED_SPECIAL_TABLE: 'Special table',
  ORDER_DELIVERY: 'Delivery',
  ORDER_PICKUP: 'Pickup',
  TABLESIDE: 'Tableside',
};

/**
 * Returns a chip-friendly label matching a given variety.
 */
export function varietyChipLabelOld(variety: core.TicketType.Variety): VarietyChipLabel {
  return varietyToVarietyChipLabelMapOld[variety];
}
